import { DialogType } from '@tableau/widgets';
import React from 'react';

import { ModalInstance, ReactModalService } from '~commonInfra/dialogs/ReactModalService';
import { IEditableServerSettings } from '~src/settings/ServerApi/types/IEditableServerSettings';
import { ISiteAuthenticationSettings } from '~src/settings/siteAuthSettings/services/SiteAuthenticationSettingsService';
import { ISiteSettingsForServerAdmin } from '~src/settings/types/ISite';
import { ISiteSettingsForSiteAdmin } from '~src/settings/types/ISiteSettingsForSiteAdmin';

import { EditSiteSettingDialog, EditSiteSettingDialogProps } from '../components/EditSiteSettingDialog';

const editSiteSettingsDialogStyle: React.CSSProperties = {
  maxHeight: '574px',
  maxWidth: '951px'
};

export  function showEditSiteDialog(settings: EditSiteSettings): Promise<any> {
  let modalInstance: ModalInstance;
  const dialogProps: EditSiteSettingDialogProps = {
    dismiss: () => modalInstance && modalInstance.dismiss(),
    close: (result: any) => modalInstance && modalInstance.close(result),
    ...settings
  };
  modalInstance = ReactModalService.open({
    type: DialogType.Uber,
    dialogContent: <EditSiteSettingDialog {...dialogProps}/>,
    testId: 'editSiteSettingDialog',
    dialogStyle: editSiteSettingsDialogStyle,
    shouldNotSetDefaultWidth: true
  });

  return modalInstance.result;
}

export interface EditSiteSettings {

serverSettings: IEditableServerSettings;
siteSettings: ISiteSettingsForSiteAdmin;
siteSettingsForServerAdmin: ISiteSettingsForServerAdmin;
siteAuthenticationSettings: ISiteAuthenticationSettings;
}
